import {Injectable} from '@angular/core';
import {UmpireStage} from '@tisa-group/models';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';
import {Observable} from 'rxjs';
import {
  CrudService,
  deserialize,
  JsonApiParams,
  JsonApiResponse,
  objectToHttpParams,
  serialize,
} from '@tisa-group/cdk';

@Injectable({
  providedIn: 'root',
})
export class StageService implements CrudService<UmpireStage> {
  constructor(readonly http: TisaUmpireHttpService) {}

  list(params?: JsonApiParams): Observable<JsonApiResponse<UmpireStage[]>> {
    return this.http
      .get(`/stages`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  fetch(
    fetchIdentifier: string,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireStage>> {
    return this.http
      .get(`/stages/${fetchIdentifier}`, {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  update(
    body: Partial<UmpireStage>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireStage>> {
    return this.http
      .patch(`/stages/${body.id}`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  create(
    body: Partial<UmpireStage>,
    params?: JsonApiParams,
  ): Observable<JsonApiResponse<UmpireStage>> {
    return this.http
      .post(`/stages`, serialize({stuff: body}), {
        params: objectToHttpParams(params),
      })
      .pipe(deserialize());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`/stages/${id}`);
  }
}
